<template>
    <div class="visualization poverty-visualization">
        <div class="viz-heading">
            <h3>{{title}}</h3>
            <el-radio-group v-model="selectedYear">
                <el-radio-button v-for="y in years" :label="y" :key="y">Año {{y}}</el-radio-button>
            </el-radio-group>


        </div>
        <div class="header">

            <div class="tabs">
                <el-tabs v-model="selectedChartId">
                    <el-tab-pane :key="c.id" v-for="c in charts" :label="c.title" :name="c.id">
                        <el-checkbox v-for="d in filters" :key="d.id" v-model="d.enabled" :label="d.id" border></el-checkbox>
                    </el-tab-pane>
                </el-tabs>
            </div>



        </div>

                <div class="chart" v-loading="loading.length">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>{{title}} - {{selectedChart.title}} - Año {{selectedYear}}</h3>
                        </div>
                        <div class="col-sm-6">
                            <div class="text-right">
                                <el-checkbox v-if="lineChart" label="Total País" v-model="lineEnabled"></el-checkbox>
                                <el-checkbox v-if="areaChart" label="Total por Región" v-model="areaEnabled"></el-checkbox>
                            </div>
                        </div>
                    </div>




                    <div v-if="states.length" class="area">
                        <el-select v-model="selectedStates" multiple placeholder="Todas las regiones">
                            <el-option v-for="s in states" :key="s" :value="s">{{s}}</el-option>
                        </el-select>
                    </div>

                    <ul class="legend">
                       <li v-for="l in labels"><span class="color" :style="{'background-color': color(l)}"></span> {{l}}</li>
                    </ul>
                    <component :is="chartType" :line-data="filteredLineData" :line-enabled="lineEnabled" :area-data="filteredAreaData" :area-enabled="areaEnabled" :data="filteredData" :dimensions="selectedChart.dimensions" :metric="metric" :color="color" :y-domain="yDomain" :numeral-format="numeralFormat"></component>
                </div>
                <div class="footer" v-loading="loading.length">
                    <div class="row">
                        <div class="col-sm-3">
                            <h4>{{title}} - Nivel País</h4>
                            <h5>{{selectedChart.title}}</h5>
                        </div>
                        <div class="col-sm-9">
                            <ul class="indicators">
                                <li v-for="d in filteredCountryData">
                                    <div class="amount">{{numeral(1*d[metric]).format(numeralFormat)}}</div>
                                    <div class="label">{{d[selectedChart.id]}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>

        </div>
    </div>
</template>
<script>
    import * as d3 from 'd3';
    import numeral from 'numeral';
    import GroupedBarChart from '../Charts/GroupedBarChart';
    import StackedBarChart from '../Charts/StackedBarChart';

    export default {
        data: function () {
            return {
                selectedStates: [],
                selectedYear: '2015',
                selectedChartId: this.initialChartId,
                areaData: [],
                areaEnabled: true,
                lineData: [],
                lineEnabled: true,
                data: [],
                countryData: [],
                filters: [],
                loading: []
            }
        },
        props: {
            title: {},
            chartType: {default: 'GroupedBarChart'},
            charts: {},
            areaChart: {},
            lineChart: {},
            initialChartId: {default: 'zona'},
            yDomain: {default: ()=>{return [0, 70]}},
            metric: {default: 'porcentaje'},
            numeralFormat: {default: '0.[00]percentage'}
        },
        components: {
            GroupedBarChart,
            StackedBarChart
        },
        computed: {
            selectedChart: function () {
                return _(this.charts).filter(c => {
                    return c.id === this.selectedChartId;
                }).head();
            },
            filteredAreaData: function () {
                return _(this.areaData)
                    .filter(d => {
                        if (this.selectedStates.length === 0)
                            return true;

                        return this.selectedStates.indexOf(d.nom_reg) >= 0;
                    })
                    .filter(d => {

                        return d.año === this.selectedYear;
                    })
                    .value();
            },
            filteredLineData: function () {
                return _(this.lineData)
                    .filter(d => {

                        return d.año === this.selectedYear;
                    })
                    .value();
            },
            filteredData: function () {
                return _(this.data)
                    .filter(d => {
                        if (this.selectedStates.length === 0)
                            return true;

                        return this.selectedStates.indexOf(d.nom_reg) >= 0;
                    })
                    .filter(d => {
                        const selectedFilters = _(this.filters).filter({enabled: true}).map(d => {
                            return d.id
                        }).value();

                        if (selectedFilters.length === 0)
                            return true;

                        return selectedFilters.indexOf(d[this.selectedChart.id]) >= 0;
                    })
                    .filter(d => {

                        return d.año === this.selectedYear;
                    })
                    .value();
            },
            filteredCountryData: function () {
                return _(this.countryData)
                    .filter({año: this.selectedYear})
                    .value();
            },
            states: function () {
                if (!_.get(this.data, '[0].nom_reg'))
                    return [];

                return _(this.data)
                    .map(d => {
                        return d.nom_reg
                    })
                    .uniq()
                    .value();
            },
            labels: function () {
                return _(this.data)
                    .map(d => {
                        return d[this.selectedChart.id]
                    })
                    .uniq()
                    .value();
            },
            years: function () {
                return _(this.data)
                    .map(d => {
                        return d.año
                    })
                    .uniq()
                    .value();
            },
            color: function () {
                return d3.scaleOrdinal(['#008000', '#DB0A5B', '#1E90FF', '#7A0177', '#3455DB']);
            }
        },
        methods: {
            numeral: numeral,
            refreshData: function () {

                this.loading.push(true);
                d3.csv(this.selectedChart.file)
                    .then((data)=>{
                        this.loading.pop();
                        this.data = data;
                        this.filters = _(this.data)
                            .uniqBy(this.selectedChart.id)
                            .map(d=>{return {
                                id: d[this.selectedChart.id],
                                enabled: true
                            }})
                            .value();
                    });

                this.loading.push(true);
                d3.csv(this.selectedChart.countryFile)
                    .then(data => {
                        this.loading.pop();
                        this.countryData = data;
                    })
            }
        },
        watch: {
            selectedChart: {
                immediate: true,
                handler: function () {
                    this.refreshData();
                }
            }
        },
        mounted: function () {
            if(this.areaChart){
                this.loading.push(true);
                d3.csv(this.areaChart.file)
                    .then((data) => {
                        this.loading.pop();
                        this.areaData = data;
                    });
            }
            if(this.lineChart){
                this.loading.push(true);
                d3.csv(this.lineChart.file)
                    .then((data) => {
                        this.loading.pop();
                        this.lineData = data;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/PovertyVisualization.vue